import { Injectable, Inject } from "@angular/core";
import {
  KreTableFieldConfig,
  KreFormFieldConfig,
  Guid,
  clone,
} from "@kre-form/core";
import { FormLayout, ICheckedField, IBusinessTable } from "./util";
import { KreToFormFieldService } from "./formFieldService";
import { filter } from "rxjs/operators";
import * as _ from "lodash";

@Injectable()
export class KreTransferService {
  constructor(
    @Inject(KreToFormFieldService)
    private toFormField: KreToFormFieldService
  ) {}

  transferLineToForm(
    form_fields: KreFormFieldConfig[],
    checkedFields: ICheckedField[]
  ) {
    let obj: KreFormFieldConfig = this.getFieldLineInfo();
    if (checkedFields && checkedFields.length > 0) {
      let checkedField = checkedFields[checkedFields.length - 1];
      form_fields.splice(checkedField.index + 1, 0, obj);
    } else {
      form_fields.push(obj);
    }
  }
  transferReferProcessToForm(
    form_fields: KreFormFieldConfig[],
    checkedFields: ICheckedField[]
  ) {
    let obj: KreFormFieldConfig = this.getFieldReferProcessInfo();
    if (checkedFields && checkedFields.length > 0) {
      let checkedField = checkedFields[checkedFields.length - 1];
      form_fields.splice(checkedField.index + 1, 0, obj);
    } else {
      form_fields.push(obj);
    }
  }

  transferAnchorToForm(
    form_fields: KreFormFieldConfig[],
    checkedFields: ICheckedField[]
  ) {
    let obj: KreFormFieldConfig = this.getFieldAnchorInfo();
    if (checkedFields && checkedFields.length > 0) {
      let checkedField = checkedFields[checkedFields.length - 1];
      form_fields.splice(checkedField.index + 1, 0, obj);
    } else {
      form_fields.push(obj);
    }
  }

  transferLabelToForm(
    form_fields: KreFormFieldConfig[],
    checkedFields: ICheckedField[]
  ) {
    let obj: KreFormFieldConfig = this.getFieldRemarkInfo();
    if (checkedFields && checkedFields.length > 0) {
      let checkedField = checkedFields[checkedFields.length - 1];
      form_fields.splice(checkedField.index + 1, 0, obj);
    } else {
      form_fields.push(obj);
    }
  }

  transferGroupToForm(
    form_fields: KreFormFieldConfig[],
    checkedFields: ICheckedField[],
    tableCode: string,
    businessTable?: IBusinessTable
  ) {
    let obj: KreFormFieldConfig = this.getFieldGroupInfo(
      tableCode,
      businessTable
    );
    obj.tableCode = tableCode;
    if (checkedFields && checkedFields.length > 0) {
      let checkedField = checkedFields[checkedFields.length - 1];
      form_fields.splice(checkedField.index + 1, 0, obj);
    } else {
      form_fields.push(obj);
    }
  }

  transferSelectFieldToForm(
    form_fields: KreFormFieldConfig[],
    checkedFields: ICheckedField[],
    businessTable: IBusinessTable,
    obj: any
  ) {
    let selectFields: any = [];
    let tableFields: KreTableFieldConfig[] = [];
    let addFields: KreFormFieldConfig[] = [];
    let beginIndex: number = 0;

    Object.getOwnPropertyNames(obj).forEach((item) => {
      if (obj[item]) {
        selectFields.push(item);
      }
    });
    if (!selectFields || selectFields.length < 1) return;
    tableFields = this.getTableFiledList(businessTable);

    if (!tableFields || tableFields.length < 1) return;

    if (form_fields && form_fields.length > 0) {
      beginIndex = form_fields.length;
    }

    selectFields.forEach((key: any) => {
      let tableField: KreTableFieldConfig = this.getTableFiledInfo(
        key,
        tableFields
      );

      if (tableField != null) {
        let formField: KreFormFieldConfig =
          this.toFormField.getKreFiledFunction(tableField);
        if (formField && formField != null) {
          addFields.push(formField);
        }
      }
    });

    if (checkedFields && checkedFields.length > 0) {
      let checkedField = checkedFields[checkedFields.length - 1];
      beginIndex = checkedField.index + 1;
    }
    addFields.forEach((item: any, index: any, object: any) => {
      form_fields.splice(beginIndex + index, 0, item);
    });
  }

  groupFieldMoveUpOrDown(
    form_fields: KreFormFieldConfig[],
    field: KreFormFieldConfig,
    type: string
  ) {
    this.clearGroupChecked(field);
    let cloneFields: KreFormFieldConfig[] = clone(form_fields);
    let cloneField: KreFormFieldConfig = clone(field);

    let checkedFields: ICheckedField[] = this.getGroupCheckFields(cloneField);
    if (checkedFields) {
      if (type === "up") {
        checkedFields.forEach((item: any) => {
          if (item.index > 0) {
            _.get(cloneField, "fieldArray.fieldGroup").splice(item.index, 1);
            _.get(cloneField, "fieldArray.fieldGroup").splice(
              item.index - 1,
              0,
              item.field
            );
          }
        });
      } else if (type === "down") {
        checkedFields.reverse().forEach((item: any) => {
          if (
            item.index <
            _.get(cloneField, "fieldArray.fieldGroup").length - 1
          ) {
            _.get(cloneField, "fieldArray.fieldGroup").splice(item.index, 1);
            _.get(cloneField, "fieldArray.fieldGroup").splice(
              item.index + 1,
              0,
              item.field
            );
          }
        });
      }
    }

    cloneFields.forEach((item: any, index: any, object: any) => {
      if (item.key === cloneField.key) {
        item.fieldArray = cloneField.fieldArray;
        if (
          item.hasOwnProperty("type") &&
          item.hasOwnProperty("fieldGroup") &&
          item.type === "repeat"
        ) {
          delete item.fieldGroup;
        }
      }
    });
    return cloneFields;
  }

  groupTransferLineToForm(
    form_fields: KreFormFieldConfig[],
    field: KreFormFieldConfig
  ) {
    this.clearGroupChecked(field);
    let cloneFields: KreFormFieldConfig[] = clone(form_fields);
    let cloneField: KreFormFieldConfig = clone(field);

    let obj = this.getFieldLineInfo();

    let checkedFields: ICheckedField[] = this.getGroupCheckFields(cloneField);
    if (!cloneField) return null;
    if (
      !cloneField.fieldArray ||
      !cloneField.fieldArray.fieldGroup ||
      cloneField.fieldArray.fieldGroup.length < 1
    ) {
      _.get(cloneField, "fieldArray.fieldGroup", []);
    }
    if (checkedFields && checkedFields.length > 0) {
      let checkedField = checkedFields[checkedFields.length - 1];
      _.get(checkedField, "checked", true);
      _.get(cloneField, "fieldArray.fieldGroup").splice(
        checkedField.index + 1,
        0,
        obj
      );
    } else {
      _.get(cloneField, "fieldArray.fieldGroup").push(obj);
    }
    cloneFields.forEach((item: any, index: any, object: any) => {
      if (item.key === cloneField.key) {
        item.fieldArray = cloneField.fieldArray;
        if (
          item.hasOwnProperty("type") &&
          item.hasOwnProperty("fieldGroup") &&
          item.type === "repeat"
        ) {
          delete item.fieldGroup;
        }
      }
    });
    return cloneFields;
  }

  groupTransferRemarkToForm(
    form_fields: KreFormFieldConfig[],
    field: KreFormFieldConfig
  ) {
    this.clearGroupChecked(field);
    let cloneFields: KreFormFieldConfig[] = clone(form_fields);
    let cloneField: KreFormFieldConfig = clone(field);

    let obj = this.getFieldRemarkInfo();

    let checkedFields: ICheckedField[] = this.getGroupCheckFields(cloneField);
    if (!cloneField) return null;
    if (
      !cloneField.fieldArray ||
      !cloneField.fieldArray.fieldGroup ||
      cloneField.fieldArray.fieldGroup.length < 1
    ) {
      _.get(cloneField, "fieldArray.fieldGroup", []);
    }
    if (checkedFields && checkedFields.length > 0) {
      let checkedField = checkedFields[checkedFields.length - 1];
      _.get(checkedField, "checked", true);
      _.get(cloneField, "fieldArray.fieldGroup").splice(
        checkedField.index + 1,
        0,
        obj
      );
    } else {
      _.get(cloneField, "fieldArray.fieldGroup").push(obj);
    }
    cloneFields.forEach((item: any, index: any, object: any) => {
      if (item.key === cloneField.key) {
        item.fieldArray = cloneField.fieldArray;
        if (
          item.hasOwnProperty("type") &&
          item.hasOwnProperty("fieldGroup") &&
          item.type === "repeat"
        ) {
          delete item.fieldGroup;
        }
      }
    });
    return cloneFields;
  }

  groupTransferSelectFieldToForm(
    form_fields: KreFormFieldConfig[],
    groupField: KreFormFieldConfig,
    checkedFields: ICheckedField[],
    businessTable: IBusinessTable,
    obj: any
  ) {
    let cloneFields: KreFormFieldConfig[] = clone(form_fields);
    let cloneGroupField: KreFormFieldConfig = clone(groupField);
    let selectFields: any = [];
    let tableFields: KreTableFieldConfig[] = [];
    let addFields: KreFormFieldConfig[] = [];
    let beginIndex: number = 0;
    Object.getOwnPropertyNames(obj).forEach((item: any) => {
      if (obj[item]) {
        selectFields.push(item);
      }
    });
    if (!selectFields || selectFields.length < 1) return;

    tableFields = this.getTableFiledList(businessTable);

    if (!tableFields || tableFields.length < 1) return;

    if (
      !cloneGroupField.fieldArray ||
      !cloneGroupField.fieldArray.fieldGroup ||
      cloneGroupField.fieldArray.fieldGroup.length < 1
    ) {
      //_.get(cloneGroupField, "fieldArray.fieldGroup", []);
      if (
        cloneGroupField.fieldArray == undefined ||
        cloneGroupField.fieldArray == null ||
        cloneGroupField.fieldArray.fieldGroup == undefined ||
        cloneGroupField.fieldArray.fieldGroup == null
      ) {
        cloneGroupField.fieldArray = {
          fieldGroup: [],
        };
      }
    }
    if (
      cloneGroupField &&
      cloneGroupField.fieldArray &&
      cloneGroupField.fieldArray.fieldGroup &&
      cloneGroupField.fieldArray.fieldGroup.length > 0
    ) {
      beginIndex = cloneGroupField.fieldArray.fieldGroup.length;
    }

    selectFields.forEach((key: any) => {
      let tableField: KreTableFieldConfig = this.getTableFiledInfo(
        key,
        tableFields
      );
      if (tableField != null) {
        let formField: KreFormFieldConfig =
          this.toFormField.getKreFiledFunction(tableField);
        if (formField && formField != null) {
          addFields.push(formField);
        }
      }
    });

    if (checkedFields && checkedFields.length > 0) {
      let checkedField = checkedFields[checkedFields.length - 1];
      beginIndex = checkedField.index + 1;
    } else {
    }

    addFields.forEach((item: any, index: any, object: any) => {
      _.get(cloneGroupField, "fieldArray.fieldGroup").splice(
        beginIndex + index,
        0,
        item
      );
    });
    cloneFields.forEach((item: any, index: any, object: any) => {
      if (item.key === cloneGroupField.key) {
        item.fieldArray = cloneGroupField.fieldArray;
        if (
          item.hasOwnProperty("type") &&
          item.hasOwnProperty("fieldGroup") &&
          item.type === "repeat"
        ) {
          delete item.fieldGroup;
        }
      }
    });
    return cloneFields;
  }

  groupTransferDeleteForm(
    form_fields: KreFormFieldConfig[],
    field: KreFormFieldConfig
  ) {
    this.clearGroupChecked(field);
    let cloneFields: KreFormFieldConfig[] = clone(form_fields);
    let cloneField: KreFormFieldConfig = clone(field);

    let checkedFields: ICheckedField[] = this.getGroupCheckFields(cloneField);

    if (!checkedFields || checkedFields == null || checkedFields.length < 1) {
      return;
    }
    if (
      !cloneField.fieldArray ||
      !cloneField.fieldArray.fieldGroup ||
      cloneField.fieldArray.fieldGroup.length < 1
    ) {
      return;
    }

    checkedFields.forEach((item: any) => {
      _.get(cloneField, "fieldArray.fieldGroup").forEach(
        (field: any, index: any, object: any) => {
          if (
            field.key === item.field.key &&
            (field.templateOptions == null ||
              field.templateOptions.isButintin == undefined ||
              field.templateOptions.isButintin == null ||
              field.templateOptions.isButintin == false)
          ) {
            object.splice(index, 1);
          }
        }
      );
    });

    cloneFields.forEach((item: any, index: any, object: any) => {
      if (item.key === cloneField.key) {
        item.fieldArray = cloneField.fieldArray;
        if (
          item.hasOwnProperty("type") &&
          item.hasOwnProperty("fieldGroup") &&
          item.type === "repeat"
        ) {
          delete item.fieldGroup;
        }
      }
    });
    return cloneFields;
  }

  /*
  groupTransferDeleteForm(
    form_fields: KreFormFieldConfig[],
    groupField: KreFormFieldConfig
  ) {
    let cloneFields: KreFormFieldConfig[] = clone(form_fields);
    let cloneGroupField: KreFormFieldConfig = clone(groupField);

    let checkedFields: ICheckedField[] =
      this.getGroupCheckFields(cloneGroupField);
    if (!checkedFields || checkedFields == null || checkedFields.length < 1) {
      return;
    }
    if (
      !cloneGroupField.fieldArray ||
      !cloneGroupField.fieldArray.fieldGroup ||
      cloneGroupField.fieldArray.fieldGroup.length < 1
    ) {
      return;
    }

    checkedFields.forEach((item: any) => {
      _.get(cloneGroupField, "fieldArray.fieldGroup").forEach(
        (field: any, index: any, object: any) => {
          if (
            field.key === item.field.key &&
            (field.templateOptions == null ||
              field.templateOptions.isButintin == undefined ||
              field.templateOptions.isButintin == null ||
              field.templateOptions.isButintin == false)
          ) {
            object.splice(index, 1);
          }
        }
      );
    });

    cloneFields.forEach((item: any, index: any, object: any) => {
      if (item.key === cloneGroupField.key) {
        item.fieldArray = cloneGroupField.fieldArray;
        if (
          item.hasOwnProperty("type") &&
          item.hasOwnProperty("fieldGroup") &&
          item.type === "repeat"
        ) {
          delete item.fieldGroup;
        }
      }
    });
    return cloneFields;
  }
  */
  editFormFieldInfo(
    form_fields: KreFormFieldConfig[],
    new_field: KreFormFieldConfig
  ) {
    if (!form_fields) return;
    let cloneFields: KreFormFieldConfig[] = clone(form_fields);
    let groupKey: string = "";
    cloneFields.forEach((field: any, index: any, object: any) => {
      if (field.type === "repeat") {
        if (field.key === new_field.key) {
          if (
            field.templateOptions == undefined ||
            field.templateOptions == null
          ) {
            field.templateOptions = {};
          }

          if (
            field.templateOptions &&
            field.templateOptions != null &&
            new_field.templateOptions &&
            new_field.templateOptions != null &&
            new_field.templateOptions.type &&
            new_field.templateOptions.type != null
          ) {
            field.templateOptions.type = new_field.templateOptions.type;
          }
          if (
            field.templateOptions &&
            field.templateOptions != null &&
            new_field.templateOptions &&
            new_field.templateOptions != null &&
            new_field.templateOptions.maxLength &&
            new_field.templateOptions.maxLength != null
          ) {
            field.templateOptions.maxLength =
              new_field.templateOptions.maxLength;
          }
          field.show = new_field.show;
          field.hide = new_field.hide;
        }
        if (
          field.fieldArray &&
          field.fieldArray.fieldGroup &&
          field.fieldArray.fieldGroup.length > 0
        ) {
          _.get(field, "fieldArray.fieldGroup").forEach(
            (groupField: any, groupIndex: any, groupObject: any) => {
              if (groupField.key === new_field.key) {
                groupKey = field.key;
                groupObject.splice(groupIndex, 1);
                groupObject.splice(groupIndex, 0, new_field);
              }
            }
          );
        }
      } else {
        if (field.key === new_field.key) {
          object.splice(index, 1);
          object.splice(index, 0, new_field);
        }
      }
    });
    if (groupKey != null && groupKey != "") {
      cloneFields.forEach((item: any, index: any, object: any) => {
        if (
          item.hasOwnProperty("type") &&
          item.hasOwnProperty("fieldGroup") &&
          item.type === "repeat"
        ) {
          delete item.fieldGroup;
        }
      });
    }
    return {
      groupKey: groupKey,
      formFileds: cloneFields,
    };
  }

  deleteFormFieldInfo(
    form_fields: KreFormFieldConfig[],
    field: KreFormFieldConfig
  ) {
    let cloneFields: KreFormFieldConfig[] = clone(form_fields);
    let cloneField: KreFormFieldConfig = clone(field);
    let groupKey: any;

    if (
      cloneFields != undefined &&
      cloneFields != null &&
      cloneField != undefined &&
      cloneField != null &&
      cloneFields.length > 0
    ) {
      if (cloneField.key != undefined && cloneField.key != null) {
        cloneFields.forEach((item: any, index: any, object: any) => {
          if (item.key === cloneField.key) {
            object.splice(index, 1);
          }
          if (
            item.fieldArray != undefined &&
            item.fieldArray != null &&
            item.fieldArray.fieldGroup != undefined &&
            item.fieldArray.fieldGroup != null
          ) {
            let res = this.deleteGroupFormFieldInfo(item, field);
            if (res != null && res != "") {
              groupKey = res;
              if (
                item.hasOwnProperty("type") &&
                item.hasOwnProperty("fieldGroup") &&
                item.type === "repeat"
              ) {
                delete item.fieldGroup;
              }
            }
          }
        });
      }
    }

    return {
      groupKey: groupKey,
      formFileds: cloneFields,
    };
  }

  private deleteGroupFormFieldInfo(
    fields: KreFormFieldConfig,
    field: KreFormFieldConfig
  ) {
    let form_fields: KreFormFieldConfig[] = [];
    let groupKey: string = "";
    if (
      fields.fieldArray != undefined &&
      fields.fieldArray != null &&
      fields.fieldArray.fieldGroup != undefined &&
      fields.fieldArray.fieldGroup != null
    ) {
      form_fields = fields.fieldArray.fieldGroup;

      if (
        form_fields != undefined &&
        form_fields != null &&
        field != undefined &&
        field != null &&
        form_fields.length > 0
      ) {
        if (field.key != undefined && field.key != null) {
          form_fields.forEach((item: any, index: any, object: any) => {
            if (item.key === field.key) {
              if (fields.key != undefined && fields.key != null) {
                groupKey = fields.key;
                object.splice(index, 1);
              }
            }
          });
        }
      }
    }
    return groupKey;
  }

  private getFieldLineInfo() {
    let obj: KreFormFieldConfig = {
      key: Guid.create()["value"],
      guid: Guid.create()["value"],
      type: "line",
      status: 1,
    };
    return obj;
  }

  private getFieldRemarkInfo() {
    let obj: KreFormFieldConfig = {
      key: Guid.create()["value"],
      guid: Guid.create()["value"],
      type: "htmlcontent",
      templateOptions: {
        description: "片段文本描述",
        isNav: true,
      },
      status: 1,
    };
    return obj;
  }

  private getFieldAnchorInfo() {
    let obj: KreFormFieldConfig = {
      key: Guid.create()["value"],
      guid: Guid.create()["value"],
      type: "anchor",
      status: 1,
    };
    return obj;
  }

  private getFieldReferProcessInfo() {
    let obj: KreFormFieldConfig = {
      key: "comprehensive$df_comprehensiveapply$associationprocess",
      guid: Guid.create()["value"],
      type: "referProcess",
      status: 1,
      templateOptions: {
        showFieldButton: false,
        type: "table",
        label: "关联流程",
      },
      fieldArray: {
        fieldGroup: [
          {
            key: "comprehensive$df_comprehensiveapply$associationprocessid",
            type: "input",
            editor: false,
            show: true,
            templateOptions: {
              isButintin: false,
              required: false,
              description: "实例ID",
              isNav: true,
              hideLabel: false,
              hiddenTree: false,
              label: "实例ID",
              placeholder: "",
              lang: "",
            },
            editProperty: {
              config: false,
            },
            id: `formly_17_select_comprehensive$df_comprehensiveapply$associationprocessid_${Math.random()}`,
            hooks: {},
            primitiveProperty: {},
          },
          {
            key: "comprehensive$df_comprehensiveapply$associationprocessname",
            type: "select",
            editor: false,
            show: true,
            templateOptions: {
              isButintin: false,
              required: false,
              description: "关联流程",
              isNav: true,
              hideLabel: false,
              hiddenTree: false,
              label: "关联流程",
              placeholder: "",
              lang: "",
            },
            editProperty: {
              config: false,
            },
            id: `formly_17_select_comprehensive$df_comprehensiveapply$associationprocessname_${Math.random()}`,
            hooks: {},
            primitiveProperty: {},
          },
        ],
      },
    };
    return obj;
  }

  private getFieldGroupInfo(tableCode: any, businessTable: any) {
    let type = "card";
    if (
      businessTable &&
      businessTable.child &&
      businessTable.child.multiple &&
      businessTable.child.multiple.length > 0
    ) {
      businessTable.child.multiple.forEach((item: any) => {
        if (
          item.tableCode === tableCode &&
          item.secondType !== undefined &&
          item.secondType !== null &&
          item.secondType !== ""
        ) {
          type = item.secondType;
        }
      });
    }
    let obj: KreFormFieldConfig = {
      key: tableCode,
      guid: Guid.create()["value"],
      type: "repeat",
      fieldArray: {
        fieldGroup: [],
      },
      templateOptions: {
        type: type,
        maxLength: 10,
      },
      tableCode: "",
      status: 1,
    };
    return obj;
  }

  //清空选中
  private clearGroupChecked(field: KreFormFieldConfig) {
    if (
      !field ||
      !field.fieldArray ||
      !field.fieldArray.fieldGroup ||
      !field.fieldGroup
    )
      return;
    field.fieldArray.fieldGroup.forEach((item: any, index: any) => {
      item.checked = false;
    });
  }

  //获取选中
  getGroupCheckFields(field: KreFormFieldConfig) {
    let checkedField: ICheckedField[] = [];
    if (
      !field ||
      !field.fieldArray ||
      !field.fieldArray.fieldGroup ||
      !field.fieldGroup ||
      field.fieldGroup.length < 1
    ) {
      return checkedField;
    }
    _.get(field, "fieldGroup[0].fieldGroup").forEach(
      (item: any, index: any) => {
        if (item.checked) {
          checkedField.push({ index: index, field: item });
          _.get(field, "fieldArray.fieldGroup")[index].checked = true;
        }
      }
    );
    return checkedField;
  }

  private getTableFiledList(businessTable: IBusinessTable) {
    let tableFields: KreTableFieldConfig[] = [];
    if (businessTable) {
      if (
        businessTable.primary &&
        businessTable.primary != null &&
        businessTable.primary.tableFields &&
        businessTable.primary.tableFields != null &&
        businessTable.primary.tableFields.length > 0
      ) {
        if (businessTable.primary.tableFields) {
          businessTable.primary.tableFields.forEach((el) => {
            el["tableCode"] = businessTable.primary.tableCode;
          });
          tableFields = tableFields.concat(businessTable.primary.tableFields);
        }
      }
      if (businessTable.child && businessTable.child != null) {
        if (
          businessTable.child.single &&
          businessTable.child.single != null &&
          businessTable.child.single.length > 0
        ) {
          businessTable.child.single.forEach((item: any) => {
            if (item.tableFields) {
              item.tableFields.forEach((el: any) => {
                el["tableCode"] = item!.tableCode;
              });
              tableFields = tableFields.concat(item.tableFields);
            }
          });
        }
        if (
          businessTable.child.multiple &&
          businessTable.child.multiple != null &&
          businessTable.child.multiple.length > 0
        ) {
          businessTable.child.multiple.forEach((item: any) => {
            if (item.tableFields) {
              item.tableFields.forEach((el: any) => {
                el["tableCode"] = item!.tableCode;
              });
              tableFields = tableFields.concat(item.tableFields);
            }
          });
        }
      }
    }
    return tableFields;
  }

  private getTableFiledInfo(key: string, tableFields: KreTableFieldConfig[]) {
    let resValue: KreTableFieldConfig = {};
    if (key && tableFields && tableFields.length > 0) {
      let filterField = tableFields.filter((item: any) => {
        return item["fieldCode"] === key;
      });
      if (filterField && filterField.length > 0) {
        return filterField[0];
      }
      return resValue;
    }
    return resValue;
  }
}
